module.exports = __webpack_public_path__ + "img/19.93cf2e80.png";